package com.eladfinish.bible.contest.screens.pyramidCrossword.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.answers_list
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.screens.mikud.ui.dialogs.SimpleMessageDialog
import com.eladfinish.bible.contest.screens.pyramidCrossword.PyramidCrosswordAction
import com.eladfinish.bible.contest.screens.pyramidCrossword.PyramidCrosswordState
import com.eladfinish.bible.contest.ui.components.dialogs.GeneralHelpDialog
import dev.icerock.moko.resources.compose.stringResource

@Composable
internal fun PyramidCrosswordDialogs(
    dialogState: PyramidCrosswordState.DialogState,
    onAction: (PyramidCrosswordAction) -> Unit,
) {
    when (dialogState) {
        is PyramidCrosswordState.DialogState.Help -> {
            GeneralHelpDialog(
                titleResource = SharedRes.strings.help,
                helpContentType = dialogState.helpContentType,
                isDontShowAgainChecked = dialogState.isDontShowAgainChecked,
                onApproveDialog = {
                    onAction(PyramidCrosswordAction.ToggleHelp(shouldShowNextTime = it))
                },
                onDismiss = {
                    onAction(PyramidCrosswordAction.HideDialog)
                },
            )
        }

        is PyramidCrosswordState.DialogState.Solutions -> {
            SimpleMessageDialog(
                title = stringResource(SharedRes.strings.answers_list),
                content = dialogState.content,
                onDismiss = { onAction(PyramidCrosswordAction.HideDialog) }
            )
        }

        PyramidCrosswordState.DialogState.None -> Unit
    }
}
